"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var FlagCU = function FlagCU(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "411.6",
    height: "270.36",
    viewBox: "0 0 411.6 270.36"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M216.6-68.33H-193v-46.61a7.06,7.06,0,0,1,7.06-7.06H209.54a7.06,7.06,0,0,1,7.06,7.06Zm0,0",
    transform: "translate(193.94 123)",
    fill: "#41479b"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M209.54,146.36H-185.94A7.06,7.06,0,0,1-193,139.3V92.69H216.6V139.3a7.06,7.06,0,0,1-7.06,7.06Zm0,0",
    transform: "translate(193.94 123)",
    fill: "#41479b"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "0.94",
    y: "54.68",
    width: "409.6",
    height: "53.67",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "0.94",
    y: "108.35",
    width: "409.6",
    height: "53.67",
    fill: "#41479b"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "0.94",
    y: "162.02",
    width: "409.6",
    height: "53.67",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-190.35,144.68,14,15.28a3.67,3.67,0,0,0,0-6.2L-190.35-120.33a7,7,0,0,0-2.65,5.39V139.3a6.93,6.93,0,0,0,2.65,5.38Zm0,0",
    transform: "translate(193.94 123)",
    fill: "#ff4b55"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-122.18-21.87l7.25,21.74L-92,.05a1.85,1.85,0,0,1,1.08,3.34L-109.36,17l6.91,21.85a1.85,1.85,0,0,1-2.84,2.06l-18.64-13.33-18.64,13.33a1.85,1.85,0,0,1-2.84-2.06L-138.5,17-156.94,3.39A1.85,1.85,0,0,1-155.85.05l22.92-.17,7.25-21.75a1.85,1.85,0,0,1,3.5,0Zm0,0",
    transform: "translate(193.94 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "1",
    y: "1",
    width: "409.6",
    height: "268.36",
    rx: "7",
    ry: "7",
    fill: "none"
  }));
};

var _default = FlagCU;
exports["default"] = _default;